import React from 'react';
import { Alert } from 'react-bootstrap';

const Message = ({variant = 'info', children}) => {
    return (
        <Alert variant={variant} children={children}>
            {children}
        </Alert>
    );
};

export default Message;